import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { toStartupAssets } from "./Calculator";
import DealInquiryModal from "../components/DealInquiryModal";
import ApplyMembershipModal from "../components/ApplyMembershipModal";
import { MembershipIntro } from "./membership/MembershipIntro";
import { MembershipBuyers } from "./membership/MembershipBuyers";
import { MembershipSellers } from "./membership/MembershipSellers";

export default function Membership() {
  const [assets, setAssets] = useState(null);
  const [dealOpen, setDealOpen] = useState(false);

  useEffect(() => {
    api.get("/public/startups").then((r) => setAssets(toStartupAssets(r.data))).catch(() => setAssets([]));
  }, []);

  return (
    <div className="min-h-screen landing-bg flex flex-col" data-testid="membership-page">
      <header className="border-b border-[#24272B] sticky top-0 z-20" style={{ background: "#0E1012" }}>
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 w-fit" data-testid="membership-home-link">
            <span className="solera-symbol" />
            <span className="wordmark text-bone text-sm">Solera Ventures</span>
            <span className="t-cap text-muted-s ml-2 hidden sm:inline fig">solera.vc</span>
          </Link>
          <div className="flex items-center gap-4 sm:gap-6">
            <ApplyMembershipModal trigger={
              <button className="t-label hover:!text-[#E8E6E1]" data-testid="membership-apply-link">Apply</button>
            } />
            <Link to="/login" className="btn-ghost !py-2 !px-5" data-testid="membership-login-link">Login</Link>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl w-full mx-auto px-6">
        <MembershipIntro />
        <MembershipBuyers assets={assets} />
        <MembershipSellers onSend={() => setDealOpen(true)} />
      </main>

      <DealInquiryModal open={dealOpen} onOpenChange={setDealOpen} />
    </div>
  );
}
